module.exports = __webpack_public_path__ + "media/images/home/hero_widget_bg_old1-37e0b5851d86e43f42ba9b5ae7cab8ea.jpg";